export enum RTSConfig {
  /** In bytes */
  MAX_DU_SIZE = 2_000_000,
}
